var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlertCardWrapper',{attrs:{"actionTitle":_vm.actionTitle,"alert":_vm.alert,"titleArr":_vm.titleArr},on:{"action-button-click":_vm.actionButtonClick},scopedSlots:_vm._u([{key:"subtitle",fn:function(){return [_c('SubTitle',{attrs:{"text":_vm.subtitle}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }